import * as types from '../../constants/event/starterPackEventConstatns';

/**
 * Starter Pack Event 목록 요청 액션 생성 함수.
 *
 * @param {number} page 페이지 번호
 * @param {number} pageLength 페이지 길이
 * @returns {Object} Starter Pack Event 목록 요청 액션 객체
 */
export const starterPackEventListRequest = (page, pageLength) => ({
  type: types.STARTER_PACK_EVENT_LIST_REQUEST,
  page,
  pageLength,
});

/**
 * Starter Pack Event 목록 업데이트 액션 생성 함수.
 *
 * @param {Array} list Event 목록
 * @returns {Object} Starter Pack Event 목록 업데이트 액션 객체
 */
export const starterPackEventList = (list) => ({
  type: types.STARTER_PACK_EVENT_LIST,
  list,
});

/**
 * Starter Pack Event 응답 메시지 액션 생성 함수.
 *
 * @param {number} resultCode 결과 코드
 * @param {string} message 메시지
 * @returns {Object} Starter Pack Event 응답 메시지 액션 객체
 */
export const starterPackEventResponse = (resultCode, message) => ({
  type: types.STARTER_PACK_EVENT_RESPONSE_MESSAGE,
  resultCode,
  message,
});

/**
 * Starter Pack Event 생성 요청 액션 생성 함수.
 *
 * @param {number} regDuration 등록 기간
 * @param {number} needUsedPower 필요한 사용 전력
 * @param {Date} beginAt 시작 일자
 * @param {Date} endAt 종료 일자
 * @param {number} rewardXper 보상 Xper
 * @param {string} rewardItem1 보상 아이템 1
 * @param {number} rewardItem1Count 보상 아이템 1 개수
 * @param {string} rewardItem2 보상 아이템 2
 * @param {number} rewardItem2Count 보상 아이템 2 개수
 * @param {string} rewardItem3 보상 아이템 3
 * @param {number} rewardItem3Count 보상 아이템 3 개수
 * @param {number} initialXper 초기 Xper
 * @returns {Object} Starter Pack Event 생성 요청 액션 객체
 */
export const starterPackEventCreate = (
  regDuration,
  needUsedPower,
  beginAt,
  endAt,
  rewardXper,
  rewardItem1,
  rewardItem1Count,
  rewardItem2,
  rewardItem2Count,
  rewardItem3,
  rewardItem3Count,
  initialXper,
) => ({
  type: types.STARTER_PACK_EVENT_CREATE_REQUEST,
  regDuration,
  needUsedPower,
  beginAt,
  endAt,
  rewardXper,
  rewardItem1,
  rewardItem1Count,
  rewardItem2,
  rewardItem2Count,
  rewardItem3,
  rewardItem3Count,
  initialXper,
});

/**
 * Starter Pack Event 정보 상세 조회 요청 액션 생성 함수.
 *
 * @param {number} packNo 스타터 팩 번호
 * @param {number} page 페이지 번호
 * @param {number} pageLength 페이지 길이
 * @param {string} searchType 검색 유형
 * @param {string} searchString 검색 문자열
 * @returns {Object} Starter Pack Event 정보 상세 조회 요청 액션 객체
 */
export const starterPackEventInfoDetailsRequest = (
  packNo,
  page,
  pageLength,
  searchType,
  searchString,
) => ({
  type: types.STARTER_PACK_EVENT_INFO_DETAILS_REQUEST,
  packNo,
  page,
  pageLength,
  searchType,
  searchString,
});

/**
 * Starter Pack Event 정보 상세 업데이트 액션 생성 함수.
 *
 * @param {Object} scheduleInfo 스케줄 정보
 * @param {Object} logInfo 로그 정보
 * @returns {Object} Starter Pack Event 정보 상세 업데이트 액션 객체
 */
export const starterPackEventInfoDetails = (scheduleInfo, logInfo) => ({
  type: types.STARTER_PACK_EVENT_INFO_DETAILS,
  scheduleInfo,
  logInfo,
});

/**
 * Starter Pack Event 정보 업데이트 요청 액션 생성 함수.
 *
 * @param {number} packNo 스타터 팩 번호
 * @param {number} regDuration 등록 기간
 * @param {number} needUsedPower 필요한 사용 전력
 * @param {Date} beginAt 시작 일자
 * @param {Date} endAt 종료 일자
 * @param {number} rewardXper 보상 Xper
 * @param {string} rewardItem1 보상 아이템 1
 * @param {number} rewardItem1Count 보상 아이템 1 개수
 * @param {string} rewardItem2 보상 아이템 2
 * @param {number} rewardItem2Count 보상 아이템 2 개수
 * @param {string} rewardItem3 보상 아이템 3
 * @param {number} rewardItem3Count 보상 아이템 3 개수
 * @param {number} initialXper Xper 총 예산
 * @returns {Object} Starter Pack Event 정보 업데이트 요청 액션 객체
 */
export const starterPackEventInfoUpdateRequest = (
  packNo,
  regDuration,
  needUsedPower,
  beginAt,
  endAt,
  rewardXper,
  rewardItem1,
  rewardItem1Count,
  rewardItem2,
  rewardItem2Count,
  rewardItem3,
  rewardItem3Count,
  initialXper,
) => ({
  type: types.STARTER_PACK_EVENT_INFO_UPDATE_REQUEST,
  packNo,
  regDuration,
  needUsedPower,
  beginAt,
  endAt,
  rewardXper,
  rewardItem1,
  rewardItem1Count,
  rewardItem2,
  rewardItem2Count,
  rewardItem3,
  rewardItem3Count,
  initialXper,
});

/**
 * Starter Pack Event 정보 삭제 요청 액션 생성 함수.
 *
 * @param {number} packNo 스타터 팩 번호
 * @returns {Object} Starter Pack Event 정보 삭제 요청 액션 객체
 */
export const starterPackEventInfoDeleteRequest = (packNo) => ({
  type: types.STARTER_PACK_EVENT_INFO_DELETE_REQUEST,
  packNo,
});

/**
 * 총 개수 설정 액션 생성 함수.
 *
 * @param {number} totalCount 총 개수
 * @returns {Object} 총 개수 설정 액션 객체
 */
export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

/**
 * Starter Pack Event 목록 페이지네이션 설정 액션 생성 함수.
 *
 * @param {number} page 페이지 번호
 * @param {number} totalCount 총 개수
 * @returns {Object} Starter Pack Event 목록 페이지네이션 설정 액션 객체
 */
export const setStarterPackEventListPagination = (page, totalCount) => ({
  type: types.SET_STARTER_PACK_EVENT_PAGINATION,
  page,
  totalCount,
});

/**
 * Starter Pack Event 히스토리 페이지네이션 설정 액션 생성 함수.
 *
 * @param {number} page 페이지 번호
 * @param {number} totalCount 총 개수
 * @param {string} searchType 검색 유형
 * @param {string} searchString 검색 문자열
 * @returns {Object} Starter Pack Event 히스토리 페이지네이션 설정 액션 객체
 */
export const setStarterPackEventHistoryPagination = (
  page,
  totalCount,
  searchType,
  searchString,
) => ({
  type: types.SET_STARTER_PACK_EVENT_PAGINATION,
  page,
  totalCount,
  searchType,
  searchString,
});

// export const starterPackEventPageReset = () => ({
//   type: types.STARTER_PACK_EVENT_PAGE_RESET,
// });

/**
 * Starter Pack Event 트랜스액션 요청 함수.
 *
 * @param {number} packNo 스타터 팩 번호
 * @param {string} transactionHash 트랜스액션해시값
 */
export const starterPackEventDepositRequest = (packNo, transactionHash) => ({
  type: types.STARTER_PACK_EVENT_DEPOSIT_REQUEST,
  packNo,
  transactionHash,
});

/**
 * Starter Pack Event 예산 추가 트랜스액션 요청 함수.
 *
 * @param {number} packNo 스타터 팩 번호
 * @param {number} addXper 추가 할 예산
 * @param {string} transactionHash 트랜스액션해시값
 */
export const starterPackEventAddBudgetRequest = (
  packNo,
  addXper,
  transactionHash,
) => ({
  type: types.STARTER_PACK_EVENT_ADD_BUDGET,
  packNo,
  addXper,
  transactionHash,
});
